import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { TrendingUpIcon, DollarSignIcon, FileTextIcon, UsersIcon } from 'lucide-react';
export function DashboardPage() {
  const navigate = useNavigate();
  const stats = [{
    label: 'Total Assets',
    value: '$1,250,000',
    change: '+12.5%',
    icon: <TrendingUpIcon className="w-6 h-6" data-id="element-1144" />,
    color: 'text-green-600'
  }, {
    label: 'Total Liabilities',
    value: '$450,000',
    change: '-3.2%',
    icon: <DollarSignIcon className="w-6 h-6" data-id="element-1145" />,
    color: 'text-red-600'
  }, {
    label: 'Active Accounts',
    value: '156',
    change: '+8',
    icon: <FileTextIcon className="w-6 h-6" data-id="element-1146" />,
    color: 'text-blue-600'
  }, {
    label: 'Total Parties',
    value: '89',
    change: '+5',
    icon: <UsersIcon className="w-6 h-6" data-id="element-1147" />,
    color: 'text-purple-600'
  }];
  return <div className="p-8" data-id="element-1148">
      <div className="max-w-7xl mx-auto space-y-8" data-id="element-1149">
        {/* Header */}
        <div data-id="element-1150">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-1151">Dashboard</h1>
          <p className="text-gray-600 mt-2" data-id="element-1152">
            Welcome to your financial management system
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1153">
          {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1154">
              <div className="flex items-center justify-between mb-4" data-id="element-1155">
                <div className={`p-3 rounded-lg bg-gray-50 ${stat.color}`} data-id="element-1156">
                  {stat.icon}
                </div>
                <span className={`text-sm font-medium ${stat.color}`} data-id="element-1157">
                  {stat.change}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1158">
                {stat.value}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-1159">{stat.label}</p>
            </div>)}
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1160">
          <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1161">
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1162">
            <Button variant="secondary" className="justify-start" onClick={() => navigate('/coa/new')} data-id="element-1163">
              <FileTextIcon className="w-4 h-4 mr-2" data-id="element-1164" />
              Create New Account
            </Button>
            <Button variant="secondary" className="justify-start" onClick={() => navigate('/coa')} data-id="element-1165">
              <FileTextIcon className="w-4 h-4 mr-2" data-id="element-1166" />
              View Chart of Accounts
            </Button>
            <Button variant="secondary" className="justify-start" data-id="element-1167">
              <UsersIcon className="w-4 h-4 mr-2" data-id="element-1168" />
              Manage Parties
            </Button>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1169">
          <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1170">
            Recent Activity
          </h2>
          <div className="space-y-4" data-id="element-1171">
            <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1172">
              <div data-id="element-1173">
                <p className="text-sm font-medium text-gray-900" data-id="element-1174">
                  New account created
                </p>
                <p className="text-xs text-gray-500" data-id="element-1175">Cash and Bank - 1100</p>
              </div>
              <span className="text-xs text-gray-500" data-id="element-1176">2 hours ago</span>
            </div>
            <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-1177">
              <div data-id="element-1178">
                <p className="text-sm font-medium text-gray-900" data-id="element-1179">
                  Account updated
                </p>
                <p className="text-xs text-gray-500" data-id="element-1180">Assets - 1000</p>
              </div>
              <span className="text-xs text-gray-500" data-id="element-1181">5 hours ago</span>
            </div>
            <div className="flex items-center justify-between py-3" data-id="element-1182">
              <div data-id="element-1183">
                <p className="text-sm font-medium text-gray-900" data-id="element-1184">
                  Account deleted
                </p>
                <p className="text-xs text-gray-500" data-id="element-1185">
                  Temporary Account - 9999
                </p>
              </div>
              <span className="text-xs text-gray-500" data-id="element-1186">1 day ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}